import { subDays } from 'date-fns'

export const initialColumns = {
  todo: {
    id: 'todo',
    name: 'To do',
    list: [
      {
        id: 3,
        title: 'Order decoration',
        description: 'This year we go with 80’s style. Get some colorful ornaments and neon lights.',
        createdDate: subDays(new Date(), 2).toISOString(),
        label: 'Annual Company Party 🎊',
        labelcolor: 'info',
        profile: '1'
      },
        {
        id: 4,
        title: 'Homepage mockup 🎨',
        description: 'First draft of the layout of the new nem site. We’ll iterate from it.',
        createdDate: subDays(new Date(), 0).toISOString(),
        label: 'Website Redesign',
        labelcolor: 'purple',
        profile: '1'
      },
    ],
  },
  inprogress: {
    id: 'inprogress',
    name: 'In progress',
    list: [
      {
        id: 1,
        title: 'Keyword research',
        description: 'Check which keywords are we ranking now, and where could we improve',
        createdDate: subDays(new Date(), 1).toISOString(),
        label: 'Website Redesign',
        labelcolor: 'purple',
        profile: '2'
      },
      {
        id: 2,
        title: 'Book venue',
        description: 'Get a quote from Grand Hotel 🏨, the local craft beer pub or a similar place.',
        createdDate: subDays(new Date(), 3).toISOString(),
        label: 'Annual Company Party 🎊',
        labelcolor: 'info',
        profile: '2'
      },
     
    ],
  },
  done: {
    id: 'done',
    name: 'Done',
    list: [],
  },
};

export const projects = [
  {
    id: 1,
    title: 'Annual Company Party 🎊',
    color: 'info',
    description: 'Offsite event with our award ceremony and choosing employee of the year.',
    createdDate: subDays(new Date(), 10),
  },
  {
    id: 2,
    title: 'Website Redesign',
    color: 'purple',
    description: 'Improve SEO and move from legacy platform',
    createdDate: subDays(new Date(), 7),
  },
  {
    id: 3,
    title: 'Product Onboarding',
    color: 'warning',
    description: '',
    createdDate: subDays(new Date(), 1),
  },
];

export const timezones = [
  {
    gmt: 'GMT-12:00',
    timeZoneValue: 'Etc/GMT-12',
  },
  {
    gmt: 'GMT-11:00',
    timeZoneValue: 'Etc/GMT-11',
  },
  {
    gmt: 'GMT-11:00',
    timeZoneValue: 'Pacific/Midway',
  },
  {
    gmt: 'GMT-10:00',
    timeZoneValue: 'America/Adak',
  },
  {
    gmt: 'GMT-09:00',
    timeZoneValue: 'America/Anchorage',
  },
  {
    gmt: 'GMT-09:00',
    timeZoneValue: 'Pacific/Gambier',
  },
  {
    gmt: 'GMT-08:00',
    timeZoneValue: 'America/Dawson_Creek',
  },
  {
    gmt: 'GMT-08:00',
    timeZoneValue: 'America/Ensenada',
  },
  {
    gmt: 'GMT-08:00',
    timeZoneValue: 'America/Los_Angeles',
  },
  {
    gmt: 'GMT-07:00',
    timeZoneValue: 'America/Chihuahua',
  },
  {
    gmt: 'GMT-07:00',
    timeZoneValue: 'America/Denver',
  },
  {
    gmt: 'GMT-06:00',
    timeZoneValue: 'America/Belize',
  },
  {
    gmt: 'GMT-06:00',
    timeZoneValue: 'America/Cancun',
  },
  {
    gmt: 'GMT-06:00',
    timeZoneValue: 'America/Chicago',
  },
  {
    gmt: 'GMT-06:00',
    timeZoneValue: 'Chile/EasterIsland',
  },
  {
    gmt: 'GMT-05:00',
    timeZoneValue: 'America/Bogota',
  },
  {
    gmt: 'GMT-05:00',
    timeZoneValue: 'America/Havana',
  },
  {
    gmt: 'GMT-05:00',
    timeZoneValue: 'America/New_York',
  },
  {
    gmt: 'GMT-04:30',
    timeZoneValue: 'America/Caracas',
  },
  {
    gmt: 'GMT-04:00',
    timeZoneValue: 'America/Campo_Grande',
  },
  {
    gmt: 'GMT-04:00',
    timeZoneValue: 'America/Glace_Bay',
  },
  {
    gmt: 'GMT-04:00',
    timeZoneValue: 'America/Goose_Bay',
  },
  {
    gmt: 'GMT-04:00',
    timeZoneValue: 'America/Santiago',
  },
  {
    gmt: 'GMT-04:00',
    timeZoneValue: 'America/La_Paz',
  },
  {
    gmt: 'GMT-03:00',
    timeZoneValue: 'America/Argentina/Buenos_Aires',
  },
  {
    gmt: 'GMT-03:00',
    timeZoneValue: 'America/Montevideo',
  },
  {
    gmt: 'GMT-03:00',
    timeZoneValue: 'America/Araguaina',
  },
  {
    gmt: 'GMT-03:00',
    timeZoneValue: 'America/Godthab',
  },
  {
    gmt: 'GMT-03:00',
    timeZoneValue: 'America/Miquelon',
  },
  {
    gmt: 'GMT-03:00',
    timeZoneValue: 'America/Sao_Paulo',
  },
  {
    gmt: 'GMT-03:30',
    timeZoneValue: 'America/St_Johns',
  },
  {
    gmt: 'GMT-02:00',
    timeZoneValue: 'America/Noronha',
  },
  {
    gmt: 'GMT-01:00',
    timeZoneValue: 'Atlantic/Cape_Verde',
  },
  {
    gmt: 'GMT',
    timeZoneValue: 'Europe/Belfast',
  },
  {
    gmt: 'GMT',
    timeZoneValue: 'Africa/Abidjan',
  },
  {
    gmt: 'GMT',
    timeZoneValue: 'Europe/Dublin',
  },
  {
    gmt: 'GMT',
    timeZoneValue: 'Europe/Lisbon',
  },
  {
    gmt: 'GMT',
    timeZoneValue: 'Europe/London',
  },
  {
    gmt: 'UTC',
    timeZoneValue: 'UTC',
  },
  {
    gmt: 'GMT+01:00',
    timeZoneValue: 'Africa/Algiers',
  },
  {
    gmt: 'GMT+01:00',
    timeZoneValue: 'Africa/Windhoek',
  },
  {
    gmt: 'GMT+01:00',
    timeZoneValue: 'Atlantic/Azores',
  },
  {
    gmt: 'GMT+01:00',
    timeZoneValue: 'Atlantic/Stanley',
  },
  {
    gmt: 'GMT+01:00',
    timeZoneValue: 'Europe/Amsterdam',
  },
  {
    gmt: 'GMT+01:00',
    timeZoneValue: 'Europe/Belgrade',
  },
  {
    gmt: 'GMT+01:00',
    timeZoneValue: 'Europe/Brussels',
  },
  {
    gmt: 'GMT+02:00',
    timeZoneValue: 'Africa/Cairo',
  },
  {
    gmt: 'GMT+02:00',
    timeZoneValue: 'Africa/Blantyre',
  },
  {
    gmt: 'GMT+02:00',
    timeZoneValue: 'Asia/Beirut',
  },
  {
    gmt: 'GMT+02:00',
    timeZoneValue: 'Asia/Damascus',
  },
  {
    gmt: 'GMT+02:00',
    timeZoneValue: 'Asia/Gaza',
  },
  {
    gmt: 'GMT+02:00',
    timeZoneValue: 'Asia/Jerusalem',
  },
  {
    gmt: 'GMT+03:00',
    timeZoneValue: 'Africa/Addis_Ababa',
  },
  {
    gmt: 'GMT+03:00',
    timeZoneValue: 'Asia/Riyadh89',
  },
  {
    gmt: 'GMT+03:00',
    timeZoneValue: 'Europe/Minsk',
  },
  {
    gmt: 'GMT+03:30',
    timeZoneValue: 'Asia/Tehran',
  },
  {
    gmt: 'GMT+04:00',
    timeZoneValue: 'Asia/Dubai',
  },
  {
    gmt: 'GMT+04:00',
    timeZoneValue: 'Asia/Yerevan',
  },
  {
    gmt: 'GMT+04:00',
    timeZoneValue: 'Europe/Moscow',
  },
  {
    gmt: 'GMT+04:30',
    timeZoneValue: 'Asia/Kabul',
  },
  {
    gmt: 'GMT+05:00',
    timeZoneValue: 'Asia/Tashkent',
  },
  {
    gmt: 'GMT+05:30',
    timeZoneValue: 'Asia/Kolkata',
  },
  {
    gmt: 'GMT+05:45',
    timeZoneValue: 'Asia/Katmandu',
  },
  {
    gmt: 'GMT+06:00',
    timeZoneValue: 'Asia/Dhaka',
  },
  {
    gmt: 'GMT+06:00',
    timeZoneValue: 'Asia/Yekaterinburg',
  },
  {
    gmt: 'GMT+06:30',
    timeZoneValue: 'Asia/Rangoon',
  },
  {
    gmt: 'GMT+07:00',
    timeZoneValue: 'Asia/Bangkok',
  },
  {
    gmt: 'GMT+07:00',
    timeZoneValue: 'Asia/Novosibirsk',
  },
  {
    gmt: 'GMT+08:00',
    timeZoneValue: 'Etc/GMT+8',
  },
  {
    gmt: 'GMT+08:00',
    timeZoneValue: 'Asia/Hong_Kong',
  },
  {
    gmt: 'GMT+08:00',
    timeZoneValue: 'Asia/Krasnoyarsk',
  },
  {
    gmt: 'GMT+08:00',
    timeZoneValue: 'Australia/Perth',
  },
  {
    gmt: 'GMT+08:45',
    timeZoneValue: 'Australia/Eucla',
  },
  {
    gmt: 'GMT+09:00',
    timeZoneValue: 'Asia/Irkutsk',
  },
  {
    gmt: 'GMT+09:00',
    timeZoneValue: 'Asia/Seoul',
  },
  {
    gmt: 'GMT+09:00',
    timeZoneValue: 'Asia/Tokyo',
  },
  {
    gmt: 'GMT+09:30',
    timeZoneValue: 'Australia/Adelaide',
  },
  {
    gmt: 'GMT+09:30',
    timeZoneValue: 'Australia/Darwin',
  },
  {
    gmt: 'GMT+09:30',
    timeZoneValue: 'Pacific/Marquesas',
  },
  {
    gmt: 'GMT+10:00',
    timeZoneValue: 'Etc/GMT+10',
  },
  {
    gmt: 'GMT+10:00',
    timeZoneValue: 'Australia/Brisbane',
  },
  {
    gmt: 'GMT+10:00',
    timeZoneValue: 'Australia/Hobart',
  },
  {
    gmt: 'GMT+10:00',
    timeZoneValue: 'Asia/Yakutsk',
  },
  {
    gmt: 'GMT+10:30',
    timeZoneValue: 'Australia/Lord_Howe',
  },
  {
    gmt: 'GMT+11:00',
    timeZoneValue: 'Asia/Vladivostok',
  },
  {
    gmt: 'GMT+11:30',
    timeZoneValue: 'Pacific/Norfolk',
  },
  {
    gmt: 'GMT+12:00',
    timeZoneValue: 'Etc/GMT+12',
  },
  {
    gmt: 'GMT+12:00',
    timeZoneValue: 'Asia/Anadyr',
  },
  {
    gmt: 'GMT+12:00',
    timeZoneValue: 'Asia/Magadan',
  },
  {
    gmt: 'GMT+12:00',
    timeZoneValue: 'Pacific/Auckland',
  },
  {
    gmt: 'GMT+12:45',
    timeZoneValue: 'Pacific/Chatham',
  },
  {
    gmt: 'GMT+13:00',
    timeZoneValue: 'Pacific/Tongatapu',
  },
  {
    gmt: 'GMT+14:00',
    timeZoneValue: 'Pacific/Kiritimati',
  },
];
